import React, { useEffect } from "react";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";
import "./BuyCredits.css";
// import Packages from "../../Components/Packages/Packages";
// import Packages2 from "../../Components/Packages2/Packages2";
import Packages from "../../Components_V2/Packages/Packages";
import Packages2 from "../../Components_V2/Packages2/Packages2";


const BuyCredits_V2 = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageHeading_V2 title={"PURCHASE"} />
      {/* <div className="buy-credits-container container">
        <Packages />
      </div> */}


      <section className="py-5" style={{ background: "#006c62" }}>
        <div className="container px-4">
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h2 className="method-heading text-uppercase text-white mb-3">
              Method 1
              <br /> Do it yourself
            </h2>
          </div>
        </div>
      </section>

      <section style={{ backgroundColor: "#0a273f" }} className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <Packages />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 0 0",
            }}
          >
           {" "}
          </div>
        </div>
      </section>
      <section className="py-5" style={{ background: "#006c62" }}>
        <div className="container px-4">
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <h2 className="method-heading my-3 text-uppercase text-white">
              Method 2
              <br /> Let us do it for you
            </h2>
          </div>
        </div>
      </section>
      <section style={{ backgroundColor: "#0a273f" }} className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <Packages2 />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "10px 0 0",
            }}
          >
            {" "}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BuyCredits_V2;

